<template>

    <div>

        <div class="TQ_text_uppercase TQ_bg_gray4 TQ_inline TQ_center">

            <tq-link :p_link_s="enum_moveToOptions.terms_termsOfUse" class="TQ_text_remove_underline TQ_inline TQ_margin_2px">
                <div class="TQ_padding_8px TQ_bg_white TQ_clickable TQ_text_bold TQ_box_shadow " :class="route_currentPath2_s().includes(enum_moveToOptions.terms_termsOfUse) ? 'TQ_bg_purple_lite' : 'TQ_bg_hover_goldLite'">
                    {{ass_strings.threeWords_termsOfUse[store_systemLangCode_ve.val]}}
                </div>
            </tq-link>

            <tq-link :p_link_s="enum_moveToOptions.terms_creatorPolicy" class="TQ_text_remove_underline TQ_inline TQ_margin_2px">
                <div class="TQ_padding_8px TQ_bg_white TQ_clickable TQ_text_bold TQ_box_shadow " :class="route_currentPath2_s().includes(enum_moveToOptions.terms_creatorPolicy) ? 'TQ_bg_purple_lite' : 'TQ_bg_hover_goldLite'">
                    {{ass_strings.twoWords_creatorPolicy[store_systemLangCode_ve.val]}}
                </div>
            </tq-link>

            <tq-link :p_link_s="enum_moveToOptions.terms_cookiePolicy" class="TQ_text_remove_underline TQ_inline TQ_margin_2px">
                <div class="TQ_padding_8px TQ_bg_white TQ_clickable TQ_text_bold TQ_box_shadow" :class="route_currentPath2_s().includes(enum_moveToOptions.terms_cookiePolicy) ? 'TQ_bg_purple_lite' : 'TQ_bg_hover_goldLite'">
                    {{ass_strings.twoWords_cookiePolicy[store_systemLangCode_ve.val]}}
                </div>
            </tq-link>

            <tq-link :p_link_s="enum_moveToOptions.terms_disclaimer" class="TQ_text_remove_underline TQ_inline TQ_margin_2px">
                <div class="TQ_padding_8px TQ_bg_white TQ_clickable TQ_text_bold TQ_box_shadow " :class="route_currentPath2_s().includes(enum_moveToOptions.terms_disclaimer) ? 'TQ_bg_purple_lite' : 'TQ_bg_hover_goldLite'">
                    {{ass_strings.oneWord_disclaimer[store_systemLangCode_ve.val]}}
                </div>
            </tq-link>

            <tq-link :p_link_s="enum_moveToOptions.terms_privacyPolicy" class="TQ_text_remove_underline TQ_inline TQ_margin_2px">
                <div class="TQ_padding_8px TQ_bg_white TQ_clickable TQ_text_bold TQ_box_shadow " :class="route_currentPath2_s().includes(enum_moveToOptions.terms_privacyPolicy) ? 'TQ_bg_purple_lite' : 'TQ_bg_hover_goldLite'">
                    {{ass_strings.twoWords_privacyPolicy[store_systemLangCode_ve.val]}}
                </div>
            </tq-link>
        </div>

        <keep-alive>
            <router-view class="TQ_padding_16px TQ_bg_white TQ_text_20px TQ_direction_ltr"/>
        </keep-alive>
    </div>

</template>

<script>
import TqLink from "@/components/basic/TqLink";
import {enum_moveToOptions} from "../../functions/src/shareCode/Share_S_Enum";
import {route_currentPath2_s, route_moveToRoute} from "@/router";
import {store_getStateValue_vo, store_setStateValue, store_var} from "@/store";
import {ass_navTabs} from "@/assets/scripts/Ass_NavTabs";
import {ass_img_info_b} from "@/assets/scripts/Ass_Files";
import {ass_strings} from "../../functions/src/shareCode/Share_Ass_Dictionary";
export default {
    name: "v_Terms",
    components: {TqLink},
    data(){
        return {
            store_systemLangCode_ve : store_getStateValue_vo(store_var.system_langCode),
            enum_moveToOptions : enum_moveToOptions,
            ass_strings : ass_strings,
            route_currentPath2_s: route_currentPath2_s
        }
    },
    created() {
        store_setStateValue(store_var.navBar_tabs_ac, [])

        store_setStateValue(store_var.navBar_menu_ac, [
            {img_r : ass_img_info_b, text_blc_s : ass_strings.oneWord_about,  onClickDo_f : () => { route_moveToRoute(enum_moveToOptions.standAlong_about)}}
        ])
    }
}
</script>

<style scoped>

</style>